var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvailsActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9C18.3137 9 21 11.6863 21 15C21 18.3137 18.3137 21 15 21C11.6863 21 9 18.3137 9 15C9 11.6863 11.6863 9 15 9ZM7 2H13V0H15V2H19C19.5523 2 20 2.44772 20 3V8H18V4H15V6H13V4H7V6H5V4H2V18H8V20H1C0.44772 20 0 19.5523 0 19V3C0 2.44772 0.44772 2 1 2H5V0H7V2ZM15 11C12.7909 11 11 12.7909 11 15C11 17.2091 12.7909 19 15 19C17.2091 19 19 17.2091 19 15C19 12.7909 17.2091 11 15 11ZM18.2744 13.4746L14.4004 17.3486L11.876 14.8242L12.7246 13.9756L14.4004 15.6514L17.4258 12.626L18.2744 13.4746Z",
    fill: "#787E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailsActiveIcon);
export default __webpack_public_path__ + "static/media/AvailsActiveIcon.f294e160e140b3bdb9e01945d135e812.svg";
export { ForwardRef as ReactComponent };